const cache = new Map();

export function storeImage(imageId, data) {
  if (!imageId) return;
  cache.set(imageId, data);
}

export function getImage(imageId) {
  return imageId ? cache.get(imageId) : null;
}

export function removeImage(imageId) {
  if (imageId) cache.delete(imageId);
}

export function newImageId() {
  return `img_${Date.now()}_${Math.random().toString(36).slice(2, 9)}`;
}
